import { ManufacturerTableconstant } from "./ManufacturerConstant";

const ManufacturerTableAction = {};

ManufacturerTableAction.getManufacturerTable = () => {
  return {
    type: ManufacturerTableconstant.MANUFACTURER_TABLE_SAGA,
  };
};

//post
ManufacturerTableAction.postAddManufacturer = (payload) => {
  return {
    type: ManufacturerTableconstant.POST_ADD_MANUFACTURER_SAGA,
    payload: payload,
  };
};

ManufacturerTableAction.getAddManufacturer = () => {
  return {
    type: ManufacturerTableconstant.GET_ADD_MANUFACTURER_SAGA,
  };
};

ManufacturerTableAction.getAddConnector = () => {
  return {
    type: ManufacturerTableconstant.GET_ADD_CONNECTORS_MODEL_SAGA,
  };
};

ManufacturerTableAction.postAddVehicleModel = (payload) => {
  return {
    type: ManufacturerTableconstant.POST_ADD_VEHICLE_MODEL_SAGA,
    payload: payload,
  };
};

ManufacturerTableAction.postAddConnectorsModel = (payload) => {
  return {
    type: ManufacturerTableconstant.POST_ADD_CONNECTORS_MODEL_SAGA,
    payload: payload,
  };
};

ManufacturerTableAction.getVehicleModelAction = () => {
  return {
    type: ManufacturerTableconstant.GET_ADD_VEHICLE_MODEL_SAGA,
  };
};

//ENABLE/DISABLE

ManufacturerTableAction.VehicleManufactureEnableDisable = ({ id, status }) => {
  return {
    type: ManufacturerTableconstant.VEHICLEMANUFACTURE_ENABLE_DISABLE_SAGA,
    payload: { id, status },
  };
};

//MANUFACTURER ENABLE/DISABLE

ManufacturerTableAction.ManufactureEnableDisable = ({ id, status }) => {
  return {
    type: ManufacturerTableconstant.MANUFACTURER_ENABLE_DISABLE_SAGA,
    payload: { id, status },
  };
};

//ENABLE/DISABLE

ManufacturerTableAction.ConnectorsEnableDisable = ({ id, status }) => {
  return {
    type: ManufacturerTableconstant.CONNECTORS_ENABLE_DISABLE_SAGA,
    payload: { id, status },
  };
};

//Add vichle manufacture action
ManufacturerTableAction.AddVehicleManufactureEnableDisable = ({
  id,
  status,
}) => {
  return {
    type: ManufacturerTableconstant.ADD_VEHICLEMANUFACTURE_ENABLE_DISABLE_SAGA,
    payload: { id, status },
  };
};

//update add manufacture

ManufacturerTableAction.UdateManufacturerAction = (payload) => {
  return {
    type: ManufacturerTableconstant.UPDATE_ADD_MANUFACTURER_SAGA,
    payload: payload,
  };
};

//update add connetor

ManufacturerTableAction.UdateConnectorAction = (payload) => {
  return {
    type: ManufacturerTableconstant.UPDATE_ADD_CONNECTOR_SAGA,
    payload: payload,
  };
};

ManufacturerTableAction.UdateVehicleModelAction = (payload) => {
  return {
    type: ManufacturerTableconstant.UPDATE_ADD_VEHICLE_MODEL_SAGA,
    payload: payload,
  };
};

//update map action

ManufacturerTableAction.UdateMapAction = (payload) => {
  return {
    type: ManufacturerTableconstant.UPDATE_MAP_SAGA,
    payload: payload,
  };
};

//action get select vehicle
ManufacturerTableAction.getSlectVehicle = () => {
  return {
    type: ManufacturerTableconstant.GET_SELECT_VEHICLE_SAGA,
  };
};

//action get select vehicle model

ManufacturerTableAction.getSlectVehicleModel = (payload) => {
  return {
    type: ManufacturerTableconstant.GET_SELECT_VEHICLE_MODEL_SAGA,
    payload: payload,
  };
};

//add vehicle varaint
ManufacturerTableAction.postAddVehicleVariant = (payload) => {
  return {
    type: ManufacturerTableconstant.POST_ADD_VEHICLE_MODEL_SAGA,
    payload: payload,
  };
};

// get vehicle variant
ManufacturerTableAction.getVehicleVariantAction = () => {
  return {
    type: ManufacturerTableconstant.GET_ADD_VEHICLE_VARIANT_SAGA,
  };
};

//edit vehicle variant

ManufacturerTableAction.UdateVehicleVariantAction = (payload) => {
  return {
    type: ManufacturerTableconstant.UPDATE_ADD_VEHICLE_VARIANT_SAGA,
    payload: payload,
  };
};

ManufacturerTableAction.vehicleModalTypeDropdown = (payload) => {
  return {
    type: ManufacturerTableconstant.VEHICLE_MODEL_TYPE_SAGA,
    payload: payload,
  };
};

export { ManufacturerTableAction };
